window.addEventListener('load', (event) => {
    // FAQs on single-advice pages.
    const faqs = document.querySelectorAll('.schema-faq-section');

    faqs.forEach((elem) => {
        elem.addEventListener('click', (e) => {
            const target = e.target.parentNode.classList.contains('schema-faq-section')
                ? e.target.parentNode
                : e.target.closest('.schema-faq-section');

            if (target && !target.classList.contains('open')) {
                target.classList.add('open');
            } else if (target) {
                target.classList.remove('open');
            }
        });
    });

    if (document.body.classList.contains('single-product')) {
        const adviceProducts = document.querySelectorAll('.faq-item');

        adviceProducts.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.stopPropagation();

                const parent = e.target.parentNode;
                parent.classList.toggle('open');
            });
        });
    }

    const showMoreFaqsButton = document.querySelector(".show-more-faqs");
    const faqContainer = document.querySelector(".faq-wrapper");
    const faqitems = document.querySelectorAll('.faq-item');
    let allFaqsShown = false;

    if (showMoreFaqsButton && faqContainer) {
        const btnTxt = showMoreFaqsButton.querySelector('.show-more-faqs-txt');
        const caret = showMoreFaqsButton.querySelector('svg');

        if (btnTxt) {
            faqitems.forEach((faq, index) => {
                faq.style.display = index < 5 ? "block" : "none";
            });

            showMoreFaqsButton.addEventListener("click", () => {
                if (!allFaqsShown) {
                    let counter = 0;

                    faqitems.forEach((faq) => {
                        if (faq.style.display === "none" && counter < 10) {
                            faq.style.display = "block";
                            counter++;
                        }
                    });

                    allFaqsShown = Array.from(faqitems).every(faq => faq.style.display === "block");

                    btnTxt.textContent = allFaqsShown ? btnTxt.dataset.close : btnTxt.dataset.open;

                    if (allFaqsShown) {
                        caret.classList.toggle('rotate');
                    }
                } else {
                    faqitems.forEach((faq, index) => {
                        if (index >= 5) {
                            faq.style.display = "none";
                        }
                    });

                    btnTxt.textContent = btnTxt.dataset.open;
                    allFaqsShown = false;

                    if (!allFaqsShown) {
                        caret.classList.toggle('rotate');
                    }
                }
            });
        }
    }
});
